export default __webpack_public_path__ + "static/media/Fala Plaska 2.add0989d.png";